// Explicit list (no HEIC) so iPhones convert camera photos to JPEG before handing them over.
export const PHOTO_ACCEPT = 'image/jpeg,image/png,image/webp';
export const PHOTO_ACCEPT_WITH_GIF = 'image/jpeg,image/png,image/webp,image/gif';

export const HEIC_MESSAGE = 'This photo is in HEIC format, which we can\'t upload. Please choose a JPEG or PNG photo, or set your iPhone camera to "Most Compatible" (Settings > Camera > Formats).';

export const isHeic = (file) => !!file && (/^image\/hei[cf](-sequence)?$/i.test(file.type || '') || /\.hei[cf]$/i.test(file.name || ''));
